module.exports = __webpack_public_path__ + "static/media/cyber_city_circuits_logo.c21a8366.png";